// Constants
const ClientHeader = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
	);

// Mixins
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins";

export default {
	name: "LandingPageHero",
    mixins: [inputTextMixins],
	components: {
		ClientHeader,
	},
	data(){
		return {

			puppyPrice: "",
            perWeekPrice: 0,
            storeCredit: process.env.VUE_APP_STORE_CREDIT,
            showMainLogo: false,
        }
    },
    mounted() {
        this.showHeaderLogo();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        onScrollView() {
            let header = document.getElementById("client-header");

			if (!header) {
				return;
			}

			if (document.body.scrollTop > 15 || document.documentElement.scrollTop > 15) {
				header.classList.add("is-sticky");
			} else {
				header.classList.remove("is-sticky");
			}
		},
		blockCurrencyInput(e) {
            const charCode = e.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46 &&
                charCode !== 190 &&
                ![8, 37, 39].includes(charCode)
            ) {
                e.preventDefault();
            } else if (charCode === 190 ? this.puppyPrice.indexOf(".") > -1 : false) {
                e.preventDefault();
            } else {
                this.delayTyping(() => {
                    this.calculateRepayments();
                });
                return true;
            }
        },
        calculateRepayments() {
            if (this.puppyPrice === "" || !this.puppyPrice) {
                return;
            }

            const puppyPrice = parseFloat(this.clearFormatting(this.puppyPrice));

            this.perWeekPrice = parseInt(
                (parseFloat(puppyPrice) + parseInt(process.env.VUE_APP_STORE_CREDIT.replaceAll(",", ""))) / 24
            );
            if (window.innerWidth <= 768) {
                const element = document.getElementById("scrollCalculate");
                element.scrollIntoView({ behavior: "smooth" });
            }
        },

        formatCurrency(value) {
            if (value !== "") {
                let val = (parseFloat(value) / 1).toFixed(2);
                return `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            } else {
                return null;
            }
        },
        clearFormatting(value) {
            value = value.replace(",", "");
            value = value.replace("$", "");
            return value;
        },
        formatCurrencyInput() {
            let amount = this.clearFormatting(this.puppyPrice);
            this.puppyPrice = this.formatCurrency(amount);
        },
        closeMobileKeyboard() {
            document.activeElement.blur();
        },
        showHeaderLogo() {
            this.showMainLogo = window.innerWidth > 1024;
        },
        handleResize() {
            this.showHeaderLogo();
        }
	},
	created() {
		window.addEventListener("scroll", this.onScrollView);
	},
	destroyed() {
		window.removeEventListener("scroll", this.onScrollView);
	},

};